<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive"
               matSort matSortActive="name" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          <span *ngIf="hasEditAccess">
            <a *ngIf="!row.recurringText" [routerLink]="[detailsUrl, 'edit', row.id]">{{row.name}}</a>
            <a *ngIf="!!row.recurringText" [routerLink]="[detailsUrl, 'edit-schedule', row.id]">{{row.name}}</a>
          </span>
          <span *ngIf="!hasEditAccess">
            {{row.number | phoneNumber}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isEnabled">
        <mat-header-cell *matHeaderCellDef mat-sort-header="isEnabled">Enabled</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Enabled:</span>
          <span>
            <span>{{row.isEnabled ? 'Yes' : 'No'}}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="keyword">
        <mat-header-cell *matHeaderCellDef mat-sort-header="keyword">Automation Options</mat-header-cell>
        <mat-cell *matCellDef="let row" style="display: block">
          <span class="mobile-label">Automation Options:</span>
          <span *ngIf="row.keyword.length > 0">Keyword: {{row.keyword}}<br/></span>
          <span *ngIf="!!row.recurringText">Recurring: {{row.recurringText}}<br/></span>
          <span *ngIf="isScheduleEnable(row)">Schedule: {{scheduleActiveDescription(row)}}<br/></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="replyMessage">
        <mat-header-cell *matHeaderCellDef mat-sort-header="replyMessage">Reply Message</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Reply Message:</span>
          <span>
            {{row.replyMessage}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="phoneNumbers">
        <mat-header-cell *matHeaderCellDef>Phone Numbers</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Phone Numbers:</span>
          <span>
            <mat-chip-row *ngFor="let item of row.phoneNumbers" [editable]="false" style="margin-right: 5px"
                          [removable]="false">
              <div class="recipient-title">
                {{ item.phoneNumber | phoneNumber }}
              </div>
            </mat-chip-row>
          </span>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
